import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '16px',
  },
  block: {
    ...dFlex('unset', 'center'),
    flexDirection: 'column',
    padding: '16px 0',
    borderRadius: theme.borderRadius.md,
    background: theme.background.b2,
    gap: '16px',
  },
}));

export default useStyles;
